import React from 'react';
import { HelpCircle } from 'lucide-react';
import { cn } from '../lib/utils';

function GalleryHeader({
  onOpenTerminal,
  onShowTutorial,
  showroomName,
  className
}) {
  return (
    <div className={cn(
      "fixed top-0 left-0 right-0 z-[998]",
      "bg-black/20 backdrop-blur-xl border-b border-white/10",
      "px-4 sm:px-6 py-3 sm:py-4",
      "flex items-center justify-between",
      className
    )}>
      {/* Left side - Terminal button */}
      <button
        onClick={onOpenTerminal}
        className={cn(
          "absolute left-4 sm:left-6 p-2",
          "hover:bg-white/10 rounded-lg transition-colors"
        )}
        title="Панель"
      >
        <img
          src="/interactive-display-icon-186423-512.png"
          alt="Terminal"
          className="w-8 h-8 brightness-0 invert"
        />
      </button>

      {/* Center - Showroom name */}
      <div className="flex items-center justify-center w-full">
        <h1 className={cn(
          "text-white/90 font-medium",
          "bg-black/30 backdrop-blur-sm",
          "px-4 py-1 rounded-lg border border-white/10",
          "max-w-md truncate text-center h-8 flex items-center"
        )}>
          {showroomName || 'Virtual Gallery'}
        </h1>
      </div>

      {/* Right side - Tutorial button */}
      <button
        onClick={onShowTutorial}
        className={cn(
          "absolute right-4 sm:right-6 p-2",
          "hover:bg-white/10 rounded-lg transition-colors"
        )}
        title="Навигация"
      >
        <HelpCircle className="w-8 h-8 text-white/80" />
      </button>
    </div>
  );
}

export default GalleryHeader;